import {
  type PermissionCode,
  type Role,
  getAuthActions,
} from '@core-frontend/core-frontend';

import { getUserInfo } from '@/pages/auth/api';
import { logout } from '@/pages/auth/model/logout';

export const getUserInfoAndUpdateStore = async (): Promise<void> => {
  const actions = getAuthActions();

  actions.setIsFetching(true);
  try {
    const data = await getUserInfo();

    const permissions = new Set<PermissionCode>(
      data.roles.flatMap((role: Role) =>
        role.role.role_permissions.map((p) => p.code_name as PermissionCode)
      )
    );
    actions.setUser(data);
    actions.setPermissions(permissions);
    actions.setIsAuthenticated(true);
  } catch (error) {
    console.error('Failed to fetch user info:', error);
    logout();
  } finally {
    actions.setIsFetching(false);
  }
};
